import { useMutation, useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "./axiosInstance";

export interface MapInvoiceRequest {
    getLimit: string;
    getPage: string;
    //운송장 목록
    company?: string;
    sDate?: string;
    eDate?: string;
    oKind?: string[];
    getOrderby?: string; // s_bl_no 등록순, o_date 업데이트순
    getAscDesc?: string; // asc
    //기사목록
    d_name?: string;
}
export interface MapInvoiceResponse {}

export const usePostMapInvoice = (successCallback?: (data: MapInvoiceResponse) => void) => {
    return useMutation({
        mutationFn: async (data: MapInvoiceRequest) => {
            const response = await axiosInstance.post(enum_api_uri.INVOICE_LIST, data);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
